/**
 * `GET /api/account/resolve-workspace` returned `/{locale}/{country}/account/…`
 * until 2026-10-22 and a bare `/account/…` since. Strip a one- or two-segment
 * two-letter prefix sitting in front of `/account`, so the portal lands right
 * against either API version while the two deploy at different times.
 */
export const LEGACY_ACCOUNT_PREFIX = /^\/[a-z]{2}(?:\/[a-z]{2})?(?=\/account(?:\/|$))/;
